"use client";

import { MetaHead } from "@/ui/navigation/MetaHead";
import { LoadingSpinner } from "@gettactic/components/src/loadings/LoadingSpinner/LoadingSpinner";
import { useOrganizationRedirect } from "@/features/dashboard/hooks/useOrganizationRedirect";
import React from "react";

const DashboardRedirect: React.FC = () => {
  useOrganizationRedirect(undefined, { preserveQueryString: true });

  return (
    <>
      <MetaHead
        title="Where office and remote work meet"
        description="Tactic helps proactive companies return to the office and make long-term decisions backed by data. Whether your office is hybrid, flexible, or merely has logistical challenges, we're here to help."
        pageURL="https://gettactic.com/"
        canonicalURL="https://www.gettactic.com"
      />
      <div className={"fixed inset-0 flex items-center justify-center"}>
        <div className="text-center">
          <LoadingSpinner />
        </div>
      </div>
    </>
  );
};

export default DashboardRedirect;
